import { Component, OnInit } from '@angular/core';
import { Select } from '@angular-redux3/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'mwo-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @Select(['remote', 'name']) playerName$: Observable<string>;
  @Select(['remote', 'client', 'name']) clientName$: Observable<string>;

  constructor() { }

  ngOnInit() {
    this.playerName$.subscribe();
    this.clientName$.subscribe();
  }

}
